import {
  EppoFeatureFlags,
  EppoExperiments,
} from './consts.js'

export const createEppoFallbackInstance = () => {
  const ff = (flag) => {
    return EppoFeatureFlags[flag]?.defaultValue
  }

  const experiment = (experiment) => {
    return EppoExperiments[experiment]?.defaultValue
  }

  const on = () => { /* do nothing */ }

  return {
    ff,
    experiment,
    on,
  }
}
